export enum ResourceType {
  Lecture = 'Lecture',
  Livestream = 'Livestream',
  EventSponsor = 'EventSponsor',
  EventChatChannel = 'EventChatChannel',
  // Community notification subjects
  Comment = 'Comment',
  ThumbsUpReaction = 'Reactions::ThumbsUp',
  CommunityPost = 'Community::Post',
}
